"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSurveyFilteredReminders = exports.rruleToFrequencyString = exports.getUserDateAsUTC = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const rrule_1 = require("rrule");
function getUserDateAsUTC(date, timezone) {
    return moment_timezone_1.default.tz(date, timezone).utc().toDate();
}
exports.getUserDateAsUTC = getUserDateAsUTC;
const rruleToFrequencyString = (rule) => {
    return (0, rrule_1.rrulestr)(rule).toText();
};
exports.rruleToFrequencyString = rruleToFrequencyString;
function getSurveyFilteredReminders(reminders) {
    if (!reminders) {
        return [];
    }
    const map = new Map();
    // Filter out duplicate reminders
    const filtered = reminders.reduce((memo, reminder) => {
        if (!map.has(reminder.duration)) {
            map.set(reminder.duration, true);
            memo.push(reminder);
        }
        return memo;
    }, []);
    // return filtered.slice(0, SurveyLimits.Reminders.Max);
    return filtered.slice(0, 2);
}
exports.getSurveyFilteredReminders = getSurveyFilteredReminders;
//# sourceMappingURL=appealsHelperUtils.js.map